// // src/components/MarkerGroup.js

// import React, { useEffect } from "react";
// import { Marker } from "@react-google-maps/api";
// import moment from "moment";
// import greenMarker from "./greencone_small.png";
// import redMarker from "./redcone_small.png";

// const MarkerGroup = ({ mapData, getMapData, user, handleShowDialog }) => {
//   useEffect(() => {
//     // Implement the function that fetches map data if needed
//     // ... your implementation here ...

//     //console.log(mapData, user)
//     return () => {
//       // Handle cleanup here if needed
//     };
//   }, []);

//   return (
//     <>
//       {user !== null ? (
//         mapData.map((data) =>
//           data.org_id === user.orgId ? (
//             <Marker
//               label={{ text: `${data.cones_left}`, className: "marker-label" }}
//               icon={moment().isAfter(data.created, "day") ? greenMarker : redMarker}
//               key={data.id}
//               position={{ lat: data.lat, lng: data.lng }}
//               onClick={() => handleShowDialog(data)}
//             />
//           ) : null
//         )
//       ) : (
//         <div>Please Log In</div>
//       )}
//     </>
//   );
// };

// export default MarkerGroup;



// src/components/MarkerGroup.js

import React from "react";
import { Marker } from "@react-google-maps/api";
import moment from "moment";
import greenMarker from "./greencone_small.png";
import redMarker from "./redcone_small.png";

const MarkerGroup = ({ mapData, user, handleShowDialog }) => {
  if (!user || !mapData) return null;

  const grouped = {};
  mapData.forEach((data) => {
    if (data.org_id === user.orgId) {
      const key = `${data.lat},${data.lng}`;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(data);
    }
  });

  const radius = 0.00007;

  return (
    <>
      {Object.values(grouped).flatMap((group) =>
        group.map((data, index) => {
          let offsetLat = data.lat;
          let offsetLng = data.lng;

          if (group.length > 1) {
            const angle = (index / group.length) * (2 * Math.PI);

            const latOffset = radius * Math.cos(angle);

            // FIX: scale longitude properly
            const lngOffset =
              (radius * Math.sin(angle)) /
              Math.cos((data.lat * Math.PI) / 180);

            offsetLat = data.lat + latOffset;
            offsetLng = data.lng + lngOffset;
          }

          return (
            <Marker
              key={data.id}
              label={{
                text: `${data.cones_left}`,
                className: "marker-label",
              }}
              icon={
                moment().diff(moment(data.created), "hours") >= 24
                  ? greenMarker
                  : redMarker
              }

              position={{ lat: offsetLat, lng: offsetLng }}
              onClick={() => handleShowDialog(data)}
            />
          );
        })
      )}
    </>
  );
};

export default MarkerGroup;
